<template>
  <v-container fluid>
    <TitleParagraphRow :value="value" />

    <v-row v-if="value.items && value.items.length">
      <v-col v-for="item in value.items" :key="item.id" cols="12" md="6">
        <v-card class="d-flex fill-height">
          <v-card-text>
            <v-row v-if="item.title || item.subtitle">
              <v-col cols="">
                <h4
                  v-if="item.title"
                  class="text-h4 text-light-blue-darken-2 font-weight-bold mb-2"
                >
                  <StyledText :value="item.title" />
                </h4>

                <h5 v-if="item.subtitle" class="text-h5">
                  <StyledText :value="item.subtitle" />
                </h5>
              </v-col>

              <v-col v-if="item.icon" cols="auto">
                <v-icon
                  v-if="typeof item.icon === 'string'"
                  :color="item.color || 'grey-darken-2'"
                  :icon="`hdf:${item.icon}`"
                  :size="item.content ? 90 : 150"
                  elevation="6"
                />
              </v-col>
            </v-row>

            <v-row v-if="item.content">
              <v-col class="text-body-1" cols="12" style="line-height: 150%">
                <ContentBlock
                  :value="item.content"
                  em-class="text-decoration-underline"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
defineProps({
  value: {
    required: true,
    type: Object
  }
})
</script>
